import { FiUser } from 'react-icons/fi';
import { AVATARS } from '../../constants/avatars';

export default function StudentDetails({ student }) {
  return (
    <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
      <div className="px-6 py-8 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-x-6">
          <img
            src={student.gender === 'Male' ? AVATARS.MALE : AVATARS.FEMALE}
            alt=""
            className="h-24 w-24 rounded-full bg-gray-100"
          />
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              {student.name}
            </h1>
            <div className="mt-2 space-y-1">
              <div className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                <FiUser className="mr-2 h-4 w-4" />
                Instructor: {student.instructor}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}